"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var contests_constants_1 = require("@biw/contests-constants");
function getManagerOverviewProps(state, program) {
    var hasStarted = program.programHasStarted;
    var objectiveHasStarted = hasStarted && program.isObjectives;
    return {
        tileType: 'manager-overview',
        programOverviewCode: hasStarted ? contests_constants_1.KEY_CODES.waitingForProgress : contests_constants_1.KEY_CODES.checkoutYourTeamsGoals,
        footerMessageCode: hasStarted ? contests_constants_1.KEY_CODES.timeToMotivate : contests_constants_1.KEY_CODES.getReady,
        buttonTextCode: hasStarted ? contests_constants_1.KEY_CODES.viewDetails : contests_constants_1.KEY_CODES.learnAboutProgram,
        daysLeft: objectiveHasStarted ? program.daysToProgramEndDate : program.daysToProgramStartDate,
        calendarLabel: objectiveHasStarted ? 'progress.daysToEarnLabel' : 'progress.daysToProgramStartLabel',
        lastDayLeftDate: hasStarted ? program.endDate : program.startDate
    };
}
exports.default = getManagerOverviewProps;
//# sourceMappingURL=overview-props.js.map